/*
  Usage: wrap a form input to disable copying and display a message when attempting to copy

  See MainsharesWeb.Components.DesignSystem.Forms.disable_input_copy_wrapper/1
*/
import { devlog } from "../utils";

const DisableCopyHook = {
  mounted() {
    this.init(this.el);
  },

  updated() {
    this.init(this.el);
  },

  init(el) {
    el.addEventListener("copy", (event) => {
      devlog("Copying is disabled by DisableCopyHook");

      toggleState(el);
      setTimeout(() => {
        toggleState(el);
      }, 3000);

      event.preventDefault();
    });
  },
};

function toggleState(el) {
  el.querySelector(".after-copy-disabled").classList.toggle("hidden");
}

export default DisableCopyHook;
